import React from 'react';

import Base64Image from '../../../lib/components/Base64Image';
import { IUnpackedFeaturedProduct } from '../../../models/MessagePreview/UnpackedFeaturedProduct';
import NewsText from './NewsText';

interface IProps {
  featuredProduct: IUnpackedFeaturedProduct;
  rankingIndex?: number;
}

const OunceFeaturedProduct = (props: IProps) => {
  const { featuredProduct, rankingIndex } = props;

  const isSwitch2 = featuredProduct.label_platform == 'ounce';

  const rankingIndexNode =
    rankingIndex ?
      <div className="ranking-index">{rankingIndex}</div> :
      null;

  const featuredProductImageClass =
    rankingIndex ?
      'featured-product-ranking-image' : (isSwitch2 ? 'featured-product-image-switch2': 'featured-product-image');

  const featuredProductDescriptionClass = rankingIndex ? 'featured-product-description-ranking' : 'featured-product-description-list' + (isSwitch2 ? ' featured-product-heigh-switch2' : '');

  const priceClass =
    featuredProduct.discount_price ?
      'featured-product-price-line-through' :
      'featured-product-price';

  const saleInfo =
    featuredProduct.sale_info ?
      <div className="featured-product-label featured-product-sale-info">{featuredProduct.sale_info}</div> :
      null;

  const demoInfo =
    featuredProduct.demo_info ?
      <div className="featured-product-label featured-product-demo-info">{featuredProduct.demo_info}</div> :
      null;

  const supplement =
    featuredProduct.supplement ?
      <NewsText text={featuredProduct.supplement} className="featured-product-supplement" tagSupported={true} /> :
      null;

  const newLabel =
    featuredProduct.new ?
      <div className="featured-product-label featured-product-new-label">{featuredProduct.new}</div> :
      null;

  const prePurchase =
    featuredProduct.pre_purchase ?
      <div className="featured-product-label featured-product-pre-perchase-label">{featuredProduct.pre_purchase}</div> :
      null;

  return (
    <div className="featured-product">
      <div className={isSwitch2 ? 'featured-product-card featured-product-heigh-switch2' : 'featured-product-card' }>
        { rankingIndexNode }
        <div className="featured-product-ranking-image-area featured-product-image-wrapper">
          {
            isSwitch2 && 
              <div className={rankingIndex ? 'featured-product-ranking-image-top-bar' : 'featured-product-image-top-bar ' }>
                <div className="featured-product-ranking-image-top-bar-icon"/>
              </div>
          }
          <Base64Image className={featuredProductImageClass} image={featuredProduct.image} />
          {
            featuredProduct.content_type && 
              <span className={'featured-product-content-type-label'}>
                {featuredProduct.content_type}
              </span>
          }
        </div>
        <div className={featuredProductDescriptionClass}>
          <div className={rankingIndex ? 'featured-product-name  featured-product-name-ranking-width': 'featured-product-name'}>
            <NewsText className="word-ellipsis" text={featuredProduct.name} />
          </div>
          <div className="featured-product-publisher">
            <NewsText text={featuredProduct.publisher} />
          </div>
          <div className="featured-product-labels">
            {newLabel}
            {prePurchase}
            {saleInfo}
            {demoInfo}
          </div>
          <div className="featured-product-price-info">
            <p className={priceClass}>{featuredProduct.regular_price}</p>
            <p className="featured-product-discount-price">{featuredProduct.discount_price}</p>
          </div>
        </div>
        <div className={isSwitch2 ? 'featured-product-wish featured-product-heigh-switch2' : 'featured-product-wish' }>
          <div className="featured-product-wish-icon"></div>
        </div>
      </div>
      <div>
        <NewsText text={featuredProduct.comment} className="featured-product-comment" tagSupported={true} />
        {supplement}
      </div>
    </div>
  );
};

export default OunceFeaturedProduct;
